import { render, staticRenderFns } from "./RegisterStocktakingDataRow.vue?vue&type=template&id=c2e22056&scoped=true&"
import script from "./RegisterStocktakingDataRow.vue?vue&type=script&lang=ts&"
export * from "./RegisterStocktakingDataRow.vue?vue&type=script&lang=ts&"
import style0 from "./RegisterStocktakingDataRow.vue?vue&type=style&index=0&id=c2e22056&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2e22056",
  null
  
)

export default component.exports